export class ContactType {
    contact_type_id: number;
    contact_type: string;
    description: string;
    admin_only: boolean;

    constructor(contact_type_id: number, contact_type: string, description: string, admin_only: boolean) {
        this.contact_type_id = contact_type_id;
        this.contact_type = contact_type;
        this.description = description;
        this.admin_only = admin_only;
    }
}
